import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initProductTheme } from "./design-system/themes";
import { initPwa } from "./pwa";
import { PwaOverlays } from "./pwa/PwaUi";
import InfoTapTip from "./components/Admin/shell/InfoTapTip";

// Apply saved product theme before first paint (default = Pace Teal / index.css).
initProductTheme();
initPwa();

// Flag proxy ESS sessions BEFORE React mounts so every auth state read
// uses sessionStorage (isolated from the admin's localStorage).
if (
  typeof window !== "undefined" &&
  (window.location.pathname.startsWith("/ess-proxy") ||
    sessionStorage.getItem("essProxySession") === "true")
) {
  sessionStorage.setItem("essProxySession", "true");
}
import { AttendanceCodeConfigProvider } from "./context/attendanceCodeConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AttendanceCodeConfigProvider>
    <App />
    <PwaOverlays />
    <InfoTapTip />
  </AttendanceCodeConfigProvider>
);
